import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const SITE_SURVEY_TEMPLATES_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('SITE_SURVEY_TEMPLATES');
export const SITE_SURVEY_TEMPLATES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	SITE_SURVEY_TEMPLATES_CRUD_ACTION_CONSTANTS
);
